import { ProductCaptureGroupType, ProductTypeEnum } from '../model/enums/product-capture.enums';

export type ProductButtonType = {
  label: string;
  hidden?: boolean;
};
export type ProductButtonMap = Map<string, ProductButtonType>;
export const CREATE_PRODUCT_BUTTONS: ProductButtonMap = new Map<
  ProductCaptureGroupType,
  ProductButtonType
>([
  ['payoff', { label: 'Payoff' }],
  ['eventSchedules', { label: 'Event Schedules' }],
  ['creditProvision', { label: 'Credit Provisions', hidden: true }],
  ['sales', { label: 'Sales' }],
  ['legalForm', { label: 'Legal Form' }],
  ['agents', { label: 'Agents' }],
  ['pricing', { label: 'Pricing' }],
  ['notesAndTasks', { label: 'Notes' }],
]);

const CAPITAL_BASE_DATA = {
  capitalBase: {
    capitalBaseType: 'FIXED',
    capitalBase: {
      value: '100%',
      minValue: null,
      indicativeValue: null,
      maxValue: null,
    },
  },
};

export const PRODUCT_POST_DATA = new Map<ProductTypeEnum, any>([
  [ProductTypeEnum.DUAL_CURRENCY_NOTE, CAPITAL_BASE_DATA],
  [
    ProductTypeEnum.FIXED_TO_FLOATING_FLOATING_TO_FIXED_RATE_NOTE,
    CAPITAL_BASE_DATA,
  ],
  [ProductTypeEnum.FLOATING_RATE_NOTE, CAPITAL_BASE_DATA],
  [ProductTypeEnum.RANGE_ACCRUAL_RATES, CAPITAL_BASE_DATA],
  [ProductTypeEnum.REVERSE_CONVERTIBLE, CAPITAL_BASE_DATA],
  [ProductTypeEnum.SUPERTRACKER, CAPITAL_BASE_DATA],
]);
